module.exports = __webpack_public_path__ + "static/media/ducktales.cb8293e5.jpg";